/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExternalCsmsConfigDto } from './ExternalCsmsConfigDto';
import {
    ExternalCsmsConfigDtoFromJSON,
    ExternalCsmsConfigDtoFromJSONTyped,
    ExternalCsmsConfigDtoToJSON,
    ExternalCsmsConfigDtoToJSONTyped,
} from './ExternalCsmsConfigDto';

/**
 * 
 * @export
 * @interface UpdateOrganizationResponseDto
 */
export interface UpdateOrganizationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationResponseDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrganizationResponseDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationResponseDto
     */
    parentId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationResponseDto
     */
    organizationType: UpdateOrganizationResponseDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationResponseDto
     */
    mainLanguage: UpdateOrganizationResponseDtoMainLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationResponseDto
     */
    createdById?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationResponseDto
     */
    updatedById?: string | null;
    /**
     * 
     * @type {ExternalCsmsConfigDto}
     * @memberof UpdateOrganizationResponseDto
     */
    externalCsmsConfig?: ExternalCsmsConfigDto | null;
}


/**
 * @export
 */
export const UpdateOrganizationResponseDtoOrganizationTypeEnum = {
    Operator: 'Operator',
    Manufacturer: 'Manufacturer',
    Landlord: 'Landlord',
    Oem: 'OEM'
} as const;
export type UpdateOrganizationResponseDtoOrganizationTypeEnum = typeof UpdateOrganizationResponseDtoOrganizationTypeEnum[keyof typeof UpdateOrganizationResponseDtoOrganizationTypeEnum];

/**
 * @export
 */
export const UpdateOrganizationResponseDtoMainLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type UpdateOrganizationResponseDtoMainLanguageEnum = typeof UpdateOrganizationResponseDtoMainLanguageEnum[keyof typeof UpdateOrganizationResponseDtoMainLanguageEnum];


/**
 * Check if a given object implements the UpdateOrganizationResponseDto interface.
 */
export function instanceOfUpdateOrganizationResponseDto(value: object): value is UpdateOrganizationResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('mainLanguage' in value) || value['mainLanguage'] === undefined) return false;
    return true;
}

export function UpdateOrganizationResponseDtoFromJSON(json: any): UpdateOrganizationResponseDto {
    return UpdateOrganizationResponseDtoFromJSONTyped(json, false);
}

export function UpdateOrganizationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'active': json['active'],
        'parentId': json['parentId'],
        'organizationType': json['organizationType'],
        'mainLanguage': json['mainLanguage'],
        'createdById': json['createdById'] == null ? undefined : json['createdById'],
        'updatedById': json['updatedById'] == null ? undefined : json['updatedById'],
        'externalCsmsConfig': json['externalCsmsConfig'] == null ? undefined : ExternalCsmsConfigDtoFromJSON(json['externalCsmsConfig']),
    };
}

export function UpdateOrganizationResponseDtoToJSON(json: any): UpdateOrganizationResponseDto {
    return UpdateOrganizationResponseDtoToJSONTyped(json, false);
}

export function UpdateOrganizationResponseDtoToJSONTyped(value?: UpdateOrganizationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
        'parentId': value['parentId'],
        'organizationType': value['organizationType'],
        'mainLanguage': value['mainLanguage'],
        'createdById': value['createdById'],
        'updatedById': value['updatedById'],
        'externalCsmsConfig': ExternalCsmsConfigDtoToJSON(value['externalCsmsConfig']),
    };
}

